import { defineComponent as _defineComponent } from 'vue'
import XIcon from '@/components/svg/x-circle-2.svg?inline';
import DownloadIcon from '@/components/svg/download-circle.svg?inline';
import SeenIcon from '@/components/svg/IsRead.svg?inline';
import ViewIcon from '@/components/svg/view-2.svg?inline';
import useContract from '@/views/my-projects/composables/useContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractFileTableButtons',
  props: {
  isDeletable: {
    type: Boolean,
    default: false
  },
  isFileSeen: {
    type: Boolean,
    default: false
  },
  isFilePdf: {
    type: Boolean,
    default: false
  }
},
  emits: ['delete-file', 'download-file', 'view-file'],
  setup(__props) {




const { events } = useContract();

const onEvent = (event: string) => {
  events.emit(event);
};

return { __sfc: true,events, onEvent, XIcon, DownloadIcon, SeenIcon, ViewIcon }
}

})